const API_URL = process.env.REACT_APP_API_URL || 'https://geroiyar.yarcloud.ru';

export const FaqService = {
  
  async fetchFaq() {
    try {
      const response = await fetch(API_URL+'/api/faq');
      if (!response.ok) throw new Error('Ошибка загрузки вопросов');
      const { data } = await response.json();
 
      return data.map((item) => ({
        id	: parseInt(item.id),
        createdAt: new Date(item.createdAt),
        question	: item.question,
        answer: item.answer
      })).sort((a,b) => a.createdAt > b.createdAt);
    } catch (error) {
      throw new Error('Не удалось загрузить вопросы: ' + error.message);
    }
  }
}